import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MatchdayComponent } from './matchday/matchday.component';
import { MatchdaycontentComponent } from './matchdaycontent/matchdaycontent.component';
import { FreeentryformComponent } from './freeentryform/freeentryform.component';
import { CarParkingComponent } from './car-parking/car-parking.component';
import { CountyChampionshipComponent } from './county-championship/county-championship.component';
import { VitalityBlastComponent } from './vitality-blast/vitality-blast.component';

const routes: Routes = [{path: "matchdayform", component: MatchdayComponent},
{path: "matchday", component: MatchdaycontentComponent},
{path: "freeentryform", component: FreeentryformComponent},
{path: "car-parking", component: CarParkingComponent},
{path: "county-championship", component: CountyChampionshipComponent},
{path: "vitality-blast-new", component: VitalityBlastComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MatchdayRoutingModule { }
